module.exports = __webpack_public_path__ + "static/media/vert.d83ceffa.png";